const withClient = client => prevProject => ({
    ...prevProject,
    client,
});

export default withClient;
